import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { EnterpriseCustomerSelectionCard } from "../components/EnterpriseCustomerState";
import { RiskResponseResolutionPanel } from "../components/RiskResponseResolutionPanel";
import { ensureEnterpriseCustomerContext } from "../lib/enterpriseCustomerContext";
import { useGetCustomerContext } from "../queries/useGetCustomerContext";
import {
  enterpriseOverviewQueryOptions,
  useGetEnterpriseOverview,
} from "../queries/useGetEnterpriseOverview";

function TeamRouteComponent() {
  const { t } = useTranslation();
  const { externalCustomerId } = Route.useSearch();
  if (!externalCustomerId) {
    return (
      <EnterpriseCustomerSelectionCard
        description={t("enterprise.routes.team.selectCustomerDescription")}
      />
    );
  }

  return <TeamRouteContent externalCustomerId={externalCustomerId} />;
}

function TeamRouteContent({
  externalCustomerId,
}: {
  externalCustomerId: string;
}) {
  const { data: customer } = useGetCustomerContext(externalCustomerId);
  const { data } = useGetEnterpriseOverview(customer.customerId);

  return (
    <RiskResponseResolutionPanel data={data} isLoading={false} error={null} />
  );
}

export const Route = createFileRoute("/_app/team")({
  loaderDeps: ({ search }) => ({
    externalCustomerId: search.externalCustomerId,
  }),
  loader: async ({ context, deps }) => {
    if (!deps.externalCustomerId) {
      return;
    }
    const customer = await ensureEnterpriseCustomerContext(
      context.queryClient,
      deps.externalCustomerId,
    );
    return context.queryClient.ensureQueryData(
      enterpriseOverviewQueryOptions(customer.customerId),
    );
  },
  component: TeamRouteComponent,
});
